(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rotating-text"] && !Shopify.designMode) return;
  try {
    class RotatingText extends HTMLElement {
    constructor() {
      super();
      this.rotatingWordEl = this.querySelector('.rotating-word');
      const rawWords = this.getAttribute('data-words');
      
      if (this.rotatingWordEl && rawWords) {
        const wordList = rawWords.split(',').map(w => w.trim()).filter(w => w.length > 0);
        let wordIdx = 0;

        if (wordList.length > 1) {
          setInterval(() => {
            this.rotatingWordEl.style.opacity = '0';
            this.rotatingWordEl.style.transform = 'translateY(15px)';

            setTimeout(() => {
              wordIdx = (wordIdx + 1) % wordList.length;
              this.rotatingWordEl.textContent = wordList[wordIdx];
              
              this.rotatingWordEl.style.transition = 'none';
              this.rotatingWordEl.style.transform = 'translateY(-15px)';

              void this.rotatingWordEl.offsetWidth; // trigger reflow

              this.rotatingWordEl.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              this.rotatingWordEl.style.opacity = '1';
              this.rotatingWordEl.style.transform = 'translateY(0)';
            }, 400); 
          }, 2500);
        }
      }
    }
  }

  if (!customElements.get('rotating-text')) {
    customElements.define('rotating-text', RotatingText);
  }
  } catch(e) { console.error(e); }
})();

})();
